export interface LanguageOption {
  code: string;
  name: string;
  shortName: string;
  flagSrc: string;
}

function svgFlag(markup: string): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 40" preserveAspectRatio="xMidYMid slice">${markup}</svg>`
  )}`;
}

export const AVAILABLE_LANGUAGES: readonly LanguageOption[] = [
  {
    code: 'en',
    name: 'English',
    shortName: 'Eng',
    flagSrc: svgFlag(
      '<rect width="60" height="40" fill="#012169"/><path d="M0 0l60 40M60 0L0 40" stroke="#fff" stroke-width="8"/><path d="M0 0l60 40M60 0L0 40" stroke="#C8102E" stroke-width="5"/><path d="M30 0v40M0 20h60" stroke="#fff" stroke-width="13"/><path d="M30 0v40M0 20h60" stroke="#C8102E" stroke-width="8"/>'
    ),
  },
  {
    code: 'ru',
    name: 'Русский',
    shortName: 'Рус',
    flagSrc: svgFlag(
      '<rect width="60" height="40" fill="#fff"/><rect y="13.33" width="60" height="13.34" fill="#0039A6"/><rect y="26.67" width="60" height="13.33" fill="#D52B1E"/>'
    ),
  },
  {
    code: 'es',
    name: 'Español',
    shortName: 'Esp',
    flagSrc: svgFlag(
      '<rect width="60" height="40" fill="#AA151B"/><rect y="10" width="60" height="20" fill="#F1BF00"/>'
    ),
  },
  {
    code: 'fr',
    name: 'Français',
    shortName: 'Fra',
    flagSrc: svgFlag(
      '<rect width="20" height="40" fill="#002395"/><rect x="20" width="20" height="40" fill="#fff"/><rect x="40" width="20" height="40" fill="#ED2939"/>'
    ),
  },
  {
    code: 'zh',
    name: '中文',
    shortName: '中文',
    flagSrc: svgFlag(
      '<rect width="60" height="40" fill="#DE2910"/><polygon fill="#FFDE00" points="12,8 13.8,13.4 8.2,10.2 15.8,10.2 10.2,13.4"/>'
    ),
  },
];

export const SUPPORTED_LANGUAGE_CODES = AVAILABLE_LANGUAGES.map(language => language.code);

export function getLanguageOption(code: string): LanguageOption {
  return AVAILABLE_LANGUAGES.find(language => language.code === code) ?? AVAILABLE_LANGUAGES[0];
}
